export const STRENGTH_THRESHOLD = 0.7
export const POTENTIAL_THRESHOLD = 0.3
export const BLINDSPOT_THRESHOLD = 0.3
export const DO_PERSPECTIVES_MATCH_THRESHOLD = 0.1
